var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormFieldSet',{staticClass:"pb-2",attrs:{"collapsible":"","headline":_vm.$t('Maschine')}},[_c('FeatureNotAvailable',{attrs:{"featureVisible":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }